export const AUTH_ROUTES = {
  SIGN_IN: {
    path: '/sign-in',
    isProtected: false,
  },
  RE_ENTRY_EXPIRED: {
    path: '/return/expired',
    isProtected: false,
  },
  RE_ENTRY_VERIFY_EMAIL: {
    path: '/return/verify-email',
    isProtected: false,
  },
  RE_ENTRY_ENTER_PHONE: {
    path: '/return/enter-phone',
    isProtected: false,
  },
  RE_ENTRY_VERIFY_PHONE: {
    path: '/return/verify-phone',
    isProtected: false,
  },
  WELCOME_BACK: {
    path: '/return/welcome-back',
    isProtected: false,
  },
}
